export default __webpack_public_path__ + "static/media/Icon ionic-md-settings.9d8146a9.svg";